import { useState } from 'react';
import { Lock } from 'lucide-react';
import SubscriptionModal from '@/components/SubscriptionModal';

interface ResultsPaywallOverlayProps {
    show: boolean;
    onUnlocked?: () => void;
}

export default function ResultsPaywallOverlay({ show }: ResultsPaywallOverlayProps) {
    const [subscriptionModalOpen, setSubscriptionModalOpen] = useState(false);

    if (!show) return null;

    return (
        <>
            <div className="absolute inset-0 bg-white/50 backdrop-blur-[6px] z-10" />

            <div className="absolute left-1/2 top-[15%] -translate-x-1/2 z-20 w-full max-w-[640px] px-4">
                <button
                    onClick={() => setSubscriptionModalOpen(true)}
                    className="flex flex-col gap-5 items-center w-full hover:scale-[1.02] transition-transform cursor-pointer"
                >
                    <div className="bg-foreground rounded-full flex items-center justify-center w-14 h-14">
                        <Lock className="w-6 h-6 text-white" />
                    </div>

                    <div className="flex flex-col gap-3 items-center text-center text-foreground max-w-[600px]">
                        <h2 className="font-condensed font-bold text-2xl uppercase leading-tight">
                            Unlock all Features and Get Your Business to Start Appearing in AI Answers
                        </h2>
                        <p className="font-sans font-normal leading-[1.5] opacity-70 text-base">
                            Unlock all results, add unlimited queries, and generate an LLMs.txt to make sure AI says the right things about your business.
                        </p>
                    </div>

                    <div className="bg-primary h-14 px-8 py-3 rounded flex items-center justify-center hover:opacity-90 transition-opacity mt-2">
                        <span className="font-mono font-medium text-base tracking-[0.7px] uppercase text-white">
                            Unlock All
                        </span>
                    </div>
                </button>
            </div>

            <SubscriptionModal
                open={subscriptionModalOpen}
                onOpenChange={setSubscriptionModalOpen}
            />
        </>
    );
}
